module.exports = __webpack_public_path__ + "static/media/ic_iphone_share.3d5c8e0c.png";